import { render, staticRenderFns } from "./Programacion.vue?vue&type=template&id=09632048&"
import script from "./Programacion.vue?vue&type=script&lang=js&"
export * from "./Programacion.vue?vue&type=script&lang=js&"
import style0 from "./Programacion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports